import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';

export const createPDF = async (formData) => {
  const pdfDoc = await PDFDocument.create();
  const page = pdfDoc.addPage([595.28, 841.89]);

  const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
  const fontSize = 12;

  // Add form data to the PDF
  page.drawText(`Name: ${formData.name}`, { x: 50, y: 750, size: fontSize, font });
  page.drawText(`RFC Number: ${formData.rfcNo}`, { x: 50, y: 700, size: fontSize, font });
  // Add other form fields here

  // Add the signature to the PDF if available
  // if (signatureDataUrl) {
  //   const signatureImage = await pdfDoc.embedPng(signatureDataUrl);
  //   const signatureDimensions = signatureImage.scale(0.2);
  //   page.drawImage(signatureImage, {
  //     x: 50,
  //     y: 650,
  //     width: signatureDimensions.width,
  //     height: signatureDimensions.height,
  //   });
  // }

  const pdfBytes = await pdfDoc.save();
  return pdfBytes;
};
